import { FC, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import Button from 'components/Button';
import Error from 'components/form/Error';
import privateAPI from 'utils/privateAxiosInstance';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 25vh;
  width: 100%;
  align-items: center;
  justify-content: center;
  h1 {
    font-size: 1.5rem;
    font-weight: 500;
    margin-bottom: 1rem;
  }
  p {
    text-align: center;
    max-width: 40rem;
  }
`;

const VerificationEmailSent: FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const [searchParams] = useSearchParams();

  const handleClick = () => {
    setLoading(true);
    setError(false);

    privateAPI
      .post('/auth/send-verification-email', {
        next: searchParams.get('next') || null,
      })
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setError(true);
      });
  };

  return (
    <Container>
      <h1>Activation du compte</h1>
      <p>Votre compte a été crée avec succès.</p>
      <p style={{ marginBottom: '3rem' }}>
        Une demande de vérification vous a été envoyée par e-mail.
      </p>
      <p style={{ marginBottom: '3rem' }}>
        Si vous n'avez rien reçu, vous pouvez demander un nouveau lien de
        vérification en cliquant sur le bouton ci-dessous.
      </p>
      <Button color="primary" loading={loading} onClick={handleClick}>
        Renvoyer un lien de vérification
      </Button>
      {error && (
        <Error style={{ marginTop: '1rem' }}>Une erreur est survenue.</Error>
      )}
    </Container>
  );
};

export default VerificationEmailSent;
